import { HelpNode, helpSectionsForRole } from "../components/HelpContent";
import { GuideButton } from "../guides/GuideProvider";
function Help({ userRole = 0 }) {
  const sections = helpSectionsForRole(userRole);
  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-4">
      <div className="rounded-[28px] bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500 p-6 text-white shadow-md">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo_vast.png`}
          alt="Vast Gym"
          width="150"
          height="60"
        />
        <h1 className="mt-5 text-3xl font-bold">Hjälp</h1>
        <p className="mt-3 max-w-3xl text-sm text-sky-50 sm:text-base">
          Här hittar du hjälp för funktionerna som är tillgängliga för din roll i Gymforvast.
        </p>
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-[280px_minmax(0,1fr)]">
        <nav className="theme-card h-fit lg:sticky lg:top-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Innehåll</p>
          <div className="mt-4 space-y-2">
            {sections.map(section => (
              <a key={section.id} className="block rounded-2xl bg-sky-50 px-4 py-3 font-medium text-sky-800 transition-colors hover:bg-sky-100" href={`#${section.id}`}>{section.title}</a>
            ))}
          </div>
        </nav>

        <main className="space-y-5">
          {userRole > 0 && <section className="theme-card" aria-label="Interaktiva guider">
            <h2 className="text-lg font-bold text-slate-800">Lär dig genom att prova</h2>
            <p className="mt-2 text-sm text-slate-600">Starta en guide i den här fliken. Du arbetar med ditt eget konto och kan avsluta när du vill. Ett befintligt passutkast behålls.</p>
            <div className="mt-3 flex flex-col items-start gap-2">
              <GuideButton id="overview" />
              <GuideButton id="videos" />
              <GuideButton id="create" />
            </div>
          </section>}
          {sections.map(section => <HelpNode key={section.id} node={section} role={userRole} />)}
        </main>
      </div>
    </div>
  );
}

export default Help;
